module.exports = __webpack_public_path__ + "img/higgs_module_3_img_3_3.09eba0d1.png";